// ContactShimmer.jsx
import React from "react";

const ContactShimmer = () => {
  return (
    <div className="min-h-screen w-full bg-[#fffdf9] animate-pulse">
      {/* Banner */}
      <div className="h-64 sm:h-72 md:h-80 bg-gray-300 relative">
        <div className="absolute inset-0 bg-gray-400 opacity-30"></div>
        <div className="relative z-10 flex flex-col items-center justify-center h-full px-4">
          <div className="h-10 w-48 sm:w-64 bg-gray-400 rounded mb-4"></div>
          <div className="h-4 w-3/4 sm:w-1/2 bg-gray-400 rounded"></div>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-20 grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 py-10 sm:py-12 lg:py-16">
        {/* Left side (Cards + Map) */}
        <div className="space-y-6">
          {/* Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {[1, 2, 3, 4, 5].map((i) => (
              <div
                key={i}
                className="h-28 sm:h-32 bg-gray-300 rounded-lg shadow-md"
              ></div>
            ))}
          </div>
          {/* Map Placeholder */}
          <div className="h-[250px] sm:h-[300px] md:h-[350px] bg-gray-300 rounded-lg shadow-md"></div>
        </div>

        {/* Right side (Form) */}
        <div className="space-y-4">
          <div className="h-8 w-40 bg-gray-400 rounded"></div>
          <div className="h-4 w-3/4 bg-gray-300 rounded"></div>
          <div className="space-y-4 mt-4">
            <div className="h-10 w-full bg-gray-300 rounded"></div>
            <div className="h-10 w-full bg-gray-300 rounded"></div>
            <div className="h-10 w-full bg-gray-300 rounded"></div>
            <div className="h-24 w-full bg-gray-300 rounded"></div>
            <div className="h-10 w-full bg-gray-400 rounded"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactShimmer;
